<template>
<b-form-group align="left">
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <label> Fecha Final: </label>
    <b-form-datepicker v-model="fechaFinal"   
    placeholder="Elije una fecha" today-button reset-button close-button label-today-button="Hoy" 
    label-reset-button="Limpiar" label-close-button="Cerrar"></b-form-datepicker>
</b-form-group>
</template>

<script>
export default {
    name: "FechaFinal",
    props: { 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        fechaFinal: null,

    }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {        
    },
    mounted() { 
    }, 
}
</script>
